import { ObjectId } from '@freightview/object-id'

import {
  vCountryAny,
  vNumber,
  vObject,
  vObjectId,
  vOptional,
  type vOutput,
  vPicklist,
  vPipe,
  vPostalCode,
  vString,
  vTransform,
} from '../validation/index.ts'

// A lot of this schema just comes from the FedEx location search endpoint
// https://www.fedex.com/us/developer/downloads/pdfs/2021/FedEx_WebServices_LocationsService_WSDLGuide_v2021.pdf

export const holdAtLocationTypes = [
  'FEDEX_AUTHORIZED_SHIP_CENTER',
  'FEDEX_EXPRESS_STATION',
  'FEDEX_FACILITY',
  'FEDEX_FREIGHT_SERVICE_CENTER',
  'FEDEX_GROUND_TERMINAL',
  'FEDEX_HOME_DELIVERY_STATION',
  'FEDEX_OFFICE',
  'FEDEX_SELF_SERVICE_LOCATION',
  'FEDEX_SHIPSITE',
  'FEDEX_SMART_POST_HUB',
] as const

export type HoldAtLocationType = (typeof holdAtLocationTypes)[number]

export const holdAtLocationSchema = vObject({
  _id: vPipe(
    vObjectId(),
    vTransform(id => ObjectId.createFromHexString(id)),
  ),
  country: vCountryAny,
  address: vString(),
  address2: vOptional(vString()),
  city: vString(),
  state: vString(),
  postalCode: vPostalCode(),
  locationId: vString(),
  locType: vPicklist(holdAtLocationTypes),
  locTypeDisplay: vString(),
  inLocation: vString(),
  mapURL: vString(),
  distance: vOptional(vNumber()),
})

export type HoldAtLocation = vOutput<typeof holdAtLocationSchema>
